<div class="location-typeahead">
    <div #inputWrap class="location-typeahead-input-wrap" [class.location-typeahead-input-wrap--bordered]="bordered"
        [class.location-typeahead-input-wrap--loading]="isLoading">
        <input #inputElement type="text" class="form-control border-0 shadow-0 bg-transparent"
            [placeholder]="placeholder" [value]="value" (input)="onInput($any($event.target).value)" (focus)="onFocus()"
            (blur)="onBlur()" (keydown.arrowdown)="onArrowDown($event)" (keydown.arrowup)="onArrowUp($event)"
            (keydown.enter)="onEnter($event)" (keydown.escape)="onEscape()" autocomplete="off" />
        <button type="button" class="location-clear-btn" *ngIf="value?.trim().length && !isLoading"
            (mousedown)="clearInput($event)" aria-label="Clear location">
            <i class="fa fa-times"></i>
        </button>
        <span class="location-spinner" *ngIf="isLoading"></span>

    </div>

    <ng-template #suggestionsContent>
        <div class="location-default-heading" *ngIf="!value?.trim().length && emptyStateSuggestions.length > 0">
            Popular Destinations
        </div>

        <div class="location-group" *ngIf="suggestionGroups.subregions.length"
            [class.with-border]="hasSuggestionsBefore('subregions')">
            <div class="location-group-label">AREAS</div>
            <button type="button" class="location-suggestion-item"
                *ngFor="let item of suggestionGroups.subregions; let i = index"
                [class.active]="isActive(i + getGroupStartIndex('subregions'))"
                (mousedown)="selectSuggestion(asSelection('subregion', item))" role="option"
                [attr.aria-selected]="isActive(i + getGroupStartIndex('subregions'))">
                <span class="location-suggestion-icon subregion"><i class="fa fa-map-marker"></i></span>
                <span class="location-suggestion-text">
                    <span class="location-suggestion-title">{{ item.name }}</span>
                    <span class="location-suggestion-sub" *ngIf="item.sublabel">{{ item.sublabel }}</span>
                </span>
            </button>
        </div>

        <div class="location-group" [class.with-border]="hasSuggestionsBefore('mappings')"
            *ngIf="suggestionGroups.mappings.length">
            <div class="location-group-label">LOCATION AREAS</div>
            <button type="button" class="location-suggestion-item"
                *ngFor="let item of suggestionGroups.mappings; let i = index"
                [class.active]="isActive(i + getGroupStartIndex('mappings'))"
                (mousedown)="selectSuggestion(asSelection('mapping', item))" role="option"
                [attr.aria-selected]="isActive(i + getGroupStartIndex('mappings'))">
                <span class="location-suggestion-icon mapping"><i class="fa fa-globe"></i></span>
                <span class="location-suggestion-text">
                    <span class="location-suggestion-title">{{ item.name }}</span>
                </span>
            </button>
        </div>

        <div class="location-group" *ngIf="suggestionGroups.regions.length"
            [class.with-border]="hasSuggestionsBefore('regions')">
            <div class="location-group-label">REGIONS</div>
            <button type="button" class="location-suggestion-item"
                *ngFor="let item of suggestionGroups.regions; let i = index"
                [class.active]="isActive(i + getGroupStartIndex('regions'))"
                (mousedown)="selectSuggestion(asSelection('region', item))" role="option"
                [attr.aria-selected]="isActive(i + getGroupStartIndex('regions'))">
                <span class="location-suggestion-icon region"><i class="fa fa-map"></i></span>
                <span class="location-suggestion-text">
                    <span class="location-suggestion-title">{{ item.name }}</span>
                    <span class="location-suggestion-sub" *ngIf="item.sublabel">{{ item.sublabel }}</span>
                </span>
            </button>
        </div>

        <div class="location-group" [class.with-border]="hasSuggestionsBefore('keywordSuggestions')"
            *ngIf="suggestionGroups.keywordSuggestions.length && value.trim().length >= minChars">
            <div class="location-group-label">POPULAR SEARCHES</div>
            <button type="button" class="location-suggestion-item"
                *ngFor="let item of suggestionGroups.keywordSuggestions; let i = index"
                [class.active]="isActive(i + getGroupStartIndex('keywordSuggestions'))"
                (mousedown)="selectSuggestion(asSelection('keyword', item))" role="option"
                [attr.aria-selected]="isActive(i + getGroupStartIndex('keywordSuggestions'))">
                <span class="location-suggestion-icon keyword"><i class="fa fa-search"></i></span>
                <span class="location-suggestion-text">
                    <span class="location-suggestion-title">{{ item.name }}</span>
                    <span class="location-suggestion-sub" *ngIf="item.sublabel">{{ item.sublabel }}</span>
                </span>
            </button>
        </div>

        <div class="location-group" *ngIf="suggestionGroups.propertyTypes.length"
            [class.with-border]="hasSuggestionsBefore('propertyTypes')">
            <div class="location-group-label">PROPERTY TYPES</div>
            <button type="button" class="location-suggestion-item"
                *ngFor="let item of suggestionGroups.propertyTypes; let i = index"
                [class.active]="isActive(i + getGroupStartIndex('propertyTypes'))"
                (mousedown)="selectSuggestion(asSelection('propertyType', item))" role="option"
                [attr.aria-selected]="isActive(i + getGroupStartIndex('propertyTypes'))">
                <span class="location-suggestion-icon type"><i class="fa fa-home"></i></span>
                <span class="location-suggestion-text">
                    <span class="location-suggestion-title">{{ item.name }}</span>
                </span>
            </button>
        </div>

        <div class="location-group" [class.with-border]="hasSuggestionsBefore('properties')"
            *ngIf="suggestionGroups.properties.length">
            <div class="location-group-label">PROPERTIES</div>
            <button type="button" class="location-suggestion-item"
                *ngFor="let item of suggestionGroups.properties; let i = index"
                [class.active]="isActive(i + getGroupStartIndex('properties'))"
                (mousedown)="selectSuggestion(asSelection('property', item))" role="option"
                [attr.aria-selected]="isActive(i + getGroupStartIndex('properties'))">
                <span class="location-suggestion-icon property"><i class="fa fa-building"></i></span>
                <span class="location-suggestion-text">
                    <span class="location-suggestion-title">{{ item.name }}</span>
                    <span class="location-suggestion-sub" *ngIf="item.sublabel">{{ item.sublabel }}</span>
                </span>
            </button>
        </div>

        <div class="location-group" [class.with-border]="getFlatSuggestions().length > 0"
            *ngIf="value.trim().length >= minChars && !isLikelyPropertyIdQuery(value)">
            <button type="button" class="location-suggestion-item keyword"
                [class.active]="isActive(getFlatSuggestions().length - 1)"
                (mousedown)="selectSuggestion({type: 'keyword', name: value.trim(), sublabel: 'Search in title, description and features'})"
                role="option" [attr.aria-selected]="isActive(getFlatSuggestions().length - 1)">
                <span class="location-suggestion-icon keyword"><i class="fa fa-search"></i></span>
                <span class="location-suggestion-text">
                    <span class="location-suggestion-title">Search for "<strong>{{ value.trim() }}</strong>"</span>
                    <span class="location-suggestion-sub">Search in title, description and features</span>
                </span>
            </button>
        </div>
    </ng-template>

    <!-- Inline suggestions (used inside panels where CDK overlay is not needed) -->
    <ng-container *ngIf="renderSuggestionsInline && showSuggestions">
        <div class="location-suggestions location-suggestions--inline" role="listbox" [attr.aria-label]="placeholder"
            [attr.aria-expanded]="showSuggestions">
            <ng-container *ngTemplateOutlet="suggestionsContent"></ng-container>
        </div>
    </ng-container>

    <ng-template #suggestionsTemplate>
        <div class="location-suggestions" role="listbox" [attr.aria-label]="placeholder"
            [attr.aria-expanded]="showSuggestions">
            <ng-container *ngTemplateOutlet="suggestionsContent"></ng-container>
        </div>
    </ng-template>
</div>